/**
 * Shared ordering for spotlight teammate pickers: actionable first, loading next, ineligible last;
 * "Myself" (when present) stays first via currentUserId.
 */
export type SpotlightMenuOption = {
	id: string;
	displayName: string;
	profilePicUrl?: string | null;
};

export const spotlightMenuSortTier = (
	option: SpotlightMenuOption,
	ctx: {
		currentUserId: string;
		canAccessSpotlight: boolean;
		eligibilityMap: Record<string, { eligible: boolean; isLoading: boolean }>;
		userIdsWithSpotlights: string[];
	}
): number => {
	if (option.id === ctx.currentUserId) {
		return 0;
	}
	const status = ctx.eligibilityMap[option.id];
	const isEligibilityLoading = !ctx.canAccessSpotlight ? false : (status?.isLoading ?? true);
	const isEligible = status?.eligible ?? false;
	const hasSpotlight = ctx.userIdsWithSpotlights.includes(option.id);
	const isDisabled = (isEligibilityLoading || !isEligible) && !hasSpotlight;
	if (isEligibilityLoading) {
		return 2;
	}
	if (!isDisabled) {
		return 1;
	}
	return 3;
};

export const sortSpotlightMenuOptions = (options: SpotlightMenuOption[], tierFor: (option: SpotlightMenuOption) => number): SpotlightMenuOption[] => {
	return [...options].sort((a, b) => {
		const ta = tierFor(a);
		const tb = tierFor(b);
		if (ta !== tb) {
			return ta - tb;
		}
		return a.displayName.localeCompare(b.displayName);
	});
};
